import { render, staticRenderFns } from "./SiteReportSection.vue?vue&type=template&id=20c6d727&scoped=true"
import script from "./SiteReportSection.vue?vue&type=script&lang=js"
export * from "./SiteReportSection.vue?vue&type=script&lang=js"
import style0 from "./SiteReportSection.vue?vue&type=style&index=0&id=20c6d727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6d727",
  null
  
)

export default component.exports